/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { ChangeDetectorRef, Component, Input, ViewChild } from '@angular/core';
import { type HttpResponse, I18nService } from '@dm/core';
import { type Host, type MappingView } from 'app/common/types/mo';
import { DataTypeId } from 'app/feature/share/global-search/global-infigo/const';
import { type Observable, forkJoin, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { InfigoService } from '../../../infigo.service';
import { RefreshComponent } from '../../RefreshComponent';
import { MappingTableComponent } from '../../resource-table/mapping-table/mapping-table.component';
import { MemberHostTableComponent } from '../../resource-table/member-host-table/member-host-table.component';

@Component({
    selector: 'app-host-group-resource',
    templateUrl: './host-group-resource.component.html',
    styleUrls: ['../../resource.scss'],
})
export class HostGroupResourceComponent extends RefreshComponent {
    @Input() data;
    @ViewChild('mappingTable', { static: true }) mappingTable: MappingTableComponent;
    @ViewChild('memberHostTable', { static: true }) memberHostTable: MemberHostTableComponent;
    firstTabItem = this.i18n.get('host.hostGroup_view_memberHost_lab');
    secondTabItem = this.i18n.get('home.search_term_mappedLUNGroup_lab');
    defaultActiveItem = this.firstTabItem;
    hostGroupId;
    mappingList: MappingView[] = [];
    hostList: Host[] = [];
    $destroy = new Subject<void>();
    loading = true;
    propName = 'data';

    constructor(private i18n: I18nService, public infigoService: InfigoService, public changeDetectorRef: ChangeDetectorRef) {
        super();
    }

    requestInfo(): Observable<any> {
        this.hostGroupId = this.data && (this.data.ID || this.data.actionParams);
        return forkJoin([this.getAssociateHosts(), this.getAssociateHostGroup()]);
    }

    handleRequest(value: any): void {
        const [host, hostGroup] = value;
        this.hostList = host.data;
        this.mappingList = hostGroup.data;
        this.loading = false;
        this.clearTimer();
        this.updateLoading = false;
        this.changeDetectorRef.detectChanges();
    }

    // 获取Host成员
    getAssociateHosts(): Observable<HttpResponse> {
        return this.infigoService.getAssociateHosts(this.hostGroupId)
            .pipe(takeUntil(this.$destroy));
    }

    // 获取LUN组关联的关联关系 - 主机组
    getAssociateHostGroup(): Observable<HttpResponse> {
        return this.infigoService.getAssociateMappings(DataTypeId[this.data.type], this.hostGroupId, [
            [
                { field: 'lunGroupId', matchMode: '!!', value: '-1' },
            ],
        ])
            .pipe(takeUntil(this.$destroy));
    }
}
